/**
 * Exhaustive switch helper — ensures all enum/union cases are handled at compile time.
 *
 * @param receivedValue - The unhandled value (typed `never` — triggers a TS error if reachable)
 * @param returnValue   - Fallback value returned at runtime if this branch is somehow reached
 * @param errorLabel    - Label used in the console.error message to identify the context
 *
 * Usage:
 *   switch (kind) {
 *     case Kinds.SELECTED: return "selected"
 *     case Kinds.PRIORITY: return "priority"
 *     case Kinds.OTHER:    return "other"
 *     default:             return assertNever(kind, "fallback", "Kinds")
 *   }
 *
 * If a new value is added to the enum and the switch is not updated,
 * TypeScript will raise a type error on the `assertNever` call.
 */
export const assertNever = <T>(
  receivedValue: never,
  returnValue: T,
  errorLabel: string,
): T => {
  console.error(`Unexpected value for ${errorLabel} : ${receivedValue}`)
  return returnValue
}
